import React from 'react';

const HeroMeta = () => {
	return (
		<dl className="hero-meta">
			<div className="hero-meta-item">
				<dt>Design &amp; development</dt>
				<dd>UX &amp; UI design</dd>
				<dd>Frontend development</dd>
				<dd>Design systems</dd>
				<dd>Accessibility</dd>
				<dd>Figma, CSS/SCSS, Angular, React, TypeScript</dd>
			</div>
			<div className="hero-meta-item">
				<dt>Languages</dt>
				<dd>Finnish, English</dd>
			</div>
			<div className="hero-meta-item">
				<dt>Location &amp; contact</dt>
				<dd>Porvoo, Finland / Helsinki area</dd>
				<dd>
					<a
						className="project-link"
						href="https://www.linkedin.com/in/noora-jumppanen/"
						target="_blank"
						rel="noopener noreferrer"
						aria-label="Noora's LinkedIn profile (opens in a new tab)"
					>
						LinkedIn profile
					</a>
				</dd>
			</div>
		</dl>
	);
};

export default HeroMeta;
